import { Building2, Landmark, ScrollText, ArrowRight } from "lucide-react";
import { nhThreeAsks } from "@/lib/northHoustonData";

const iconForId = { 1: Building2, 2: Landmark, 3: ScrollText };

export default function ThreeAsksNH() {
  return (
    <section
      id="asks"
      data-testid="section-three-asks-nh"
      className="bg-[#0A192F] text-[#F9F7F1] py-16 lg:py-20 relative overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0 grain-overlay opacity-20" />
      <div
        aria-hidden
        className="absolute -top-24 -left-24 w-[400px] h-[400px] rounded-full bg-[#D4AF37]/10 blur-3xl"
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-12 items-baseline">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-[#D4AF37]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#D4AF37]">
                The Asks at a Glance · 60-Second Read
              </span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-tight">
              Three asks. <em className="italic text-[#D4AF37]">Three signatures.</em>
            </h2>
          </div>
          <div className="lg:col-span-5 text-[#CBD5E1] leading-relaxed">
            <p>
              If you only have a minute, here is exactly what Bridge Proposal 02 — North
              Houston District — needs to launch. Click any of the three to jump
              directly to the detailed section.
            </p>
          </div>
        </div>

        <ol className="grid md:grid-cols-3 gap-px bg-[#F9F7F1]/15 border border-[#F9F7F1]/15">
          {nhThreeAsks.map((a) => {
            const Icon = iconForId[a.id] || Building2;
            return (
              <li
                key={a.id}
                data-testid={`three-ask-nh-${a.id}`}
                className="bg-[#0A192F] p-6 lg:p-7 flex flex-col"
              >
                <div className="flex items-center justify-between mb-4">
                  <Icon className="h-6 w-6 text-[#D4AF37]" />
                  <span className="font-mono text-[10px] uppercase tracking-widest text-[#D4AF37]">
                    0{a.id}
                  </span>
                </div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-[#94A3B8] mb-2">
                  {a.label}
                </div>
                <h3 className="font-display text-lg lg:text-xl text-[#F9F7F1] leading-snug mb-3">
                  {a.title}
                </h3>
                <p className="text-xs lg:text-sm text-[#CBD5E1] leading-relaxed flex-1 mb-5">
                  {a.body}
                </p>
                <a
                  href={a.anchor}
                  data-testid={`three-ask-nh-anchor-${a.id}`}
                  className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-[#D4AF37] hover:text-[#F9F7F1] transition-colors mt-auto"
                >
                  {a.anchorLabel} <ArrowRight className="h-3 w-3" />
                </a>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
